import { SvgIcon, SvgIconProps } from "@mui/material";
import MuiCheckbox from "@mui/material/Checkbox";
import { CheckboxProps as MuiCheckboxProps } from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

const UncheckedIcon = ({ sx, ...props }: Omit<SvgIconProps, "fontSize">) => (
  <SvgIcon {...props} sx={{ height: "16px", width: "16px", ...sx }}>
    <svg height="16px" width="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" />
    </svg>
  </SvgIcon>
);

const CheckedIcon = ({ sx, ...props }: Omit<SvgIconProps, "fontSize">) => (
  <SvgIcon
    {...props}
    sx={{ backgroundColor: "secondary1.100", borderRadius: "4px", height: "16px", width: "16px", ...sx }}
  >
    <svg height="16px" width="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5.33333L6.5 10.6667L4 8.24242"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export interface CheckboxProps extends MuiCheckboxProps {
  error?: boolean;
}

const Checkbox = styled((props: CheckboxProps) => {
  const { error, ...rest } = props;
  return (
    <MuiCheckbox
      disableFocusRipple
      {...rest}
      data-error={props.error}
      icon={<UncheckedIcon />}
      checkedIcon={<CheckedIcon />}
    />
  );
})(({ theme }) => ({
  height: "26px",
  width: "26px",
  color: theme.palette.grey[60],
  marginRight: "4px",
  justifyContent: "center",
  alignItems: "center",

  "&:not(.Mui-checked)": {
    stroke: theme.palette.grey[60],
    "&:hover rect": {
      stroke: theme.palette.grey[100],
    },
  },

  "&.Mui-disabled": {
    opacity: 0.3,
  },

  "&.Mui-checked": {
    "&:hover": {
      backgroundColor: theme.palette.grey[20],
    },
  },

  "&.Mui-focusVisible": {
    borderRadius: "4px",
    backgroundColor: "transparent",
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: "-3px",
    transition: "outline-offset 0s, outline 0s",
  },

  "&[data-error='true']": {
    stroke: theme.palette.error.main,
    "&:hover rect": {
      stroke: theme.palette.error.main,
    },
  },
}));

export default Checkbox;
